import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { findProductById, findProducts } from "../Redux/Customers/Product/Action";
import Navbar from "./Navbar";
import RelatedProducts from "./RelatedProducts";
import { addItemToCart } from "../Redux/Customers/Cart/Action";
import { Loader } from "./Loader";
import Footer from "./Footer";

const ProductDetail = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { product, loading, error } = useSelector((store) => store.customersProduct);
    const { products } = useSelector((store) => store.customersProduct);

    const navigate = useNavigate();

    const [selectedColor, setSelectedColor] = useState("");
    const [selectedSize, setSelectedSize] = useState("");

    useEffect(() => {
        const data = {
            category: "",
            colors: [],
            sizes: [],
            minPrice: 0,
            maxPrice: 100000,
            minDiscount: 0,
            sort: "price_low",
            pageNumber: 1,
            pageSize: 10,
            stock: "in_stock",
        };
        dispatch(findProducts(data));
    }, [dispatch]);

    useEffect(() => {
        const reqData = { productId: id };
        dispatch(findProductById(reqData));
    }, [dispatch, id]);

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    const jwt = localStorage.getItem("jwt");

    const handleSubmit = () => {
        const data = { productId: id, color: selectedColor, size: selectedSize };
        dispatch(addItemToCart({ data, jwt }));
        if (!jwt) {
            return navigate("/sign-in");
        }
        navigate("/cart");
    };

    return (
        <>
            <Navbar />
            <div className="py-12 bg-[#0a0a0a] flex justify-center w-full pt-36 px-4 md:px-0">
                <div className="flex flex-col md:flex-row items-center justify-center gap-10 w-full md:w-4/5">
                    {/* Product Image Section */}
                    <div className="flex-1 w-full md:w-auto">
                        <img
                            src={product?.imageUrl}
                            alt={product?.title}
                            className="w-full h-auto max-w-lg object-cover"
                        />
                    </div>

                    {/* Product Details Section */}
                    <div className="flex-1 w-full md:w-auto text-white text-center md:text-left">
                        <h1 className="text-2xl md:text-4xl font-bold">{product?.title}</h1>

                        <p className="mt-2 text-lg md:text-xl">Brand: {product?.brand}</p>

                        <p className="mt-4 text-xl md:text-2xl">
                            ₹{product?.discountedPrice} <span className="line-through text-gray-400">₹{product?.price}</span>
                        </p>
                        <p className="mt-2 text-lg text-green-400">
                            Save {product?.discountPersent}% ({product?.price - product?.discountedPrice} off)
                        </p>

                        {/* Color Selection */}
                        <div className="mt-6">
                            <p className="text-lg mb-2">Select Color:</p>
                            <div className="flex flex-wrap gap-4 justify-center md:justify-start">
                                {product?.colors?.map((color) => (
                                    <button
                                        key={color.name}
                                        onClick={() => setSelectedColor(color.name)}
                                        className={`w-12 h-12 rounded-full border text-white ${selectedColor === color.name ? "border-white" : "border-gray-500"}`}
                                        style={{ backgroundColor: color.name }}
                                    >
                                        {/* Display color name */}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Size Selection */}
                        <div className="mt-6">
                            <p className="text-lg mb-2">Select Size:</p>
                            <div className="flex flex-wrap gap-4 justify-center md:justify-start">
                                {product?.colors?.find(color => color.name === selectedColor)?.sizes?.map((size) => (
                                    <button
                                        key={size._id}
                                        onClick={() => setSelectedSize(size.size)}
                                        className={`w-12 h-12 rounded-full border ${selectedSize === size.size ? "border-white bg-gray-700" : "border-gray-500"} text-white`}
                                    >
                                        {size.size}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Add to Bag Button */}
                        <div className="mt-8">
                            <button
                                className="px-8 py-3 bg-gray-600 text-white rounded hover:bg-gray-700 transition"
                                disabled={!selectedColor || !selectedSize}
                                onClick={handleSubmit}
                            >
                                Add to Bag
                            </button>
                        </div>

                        {/* Product Description */}
                        <div className="mt-8">
                            <p className="text-gray-400 mt-2">
                                {product?.description}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <RelatedProducts relatedProducts={products} />
            <Footer />
        </>
    );
};

export default ProductDetail;
